<template>
  <div id="app">
    <c-full />
  </div>
</template>

<script>
import cFull from '@/components/layout/c-full/index.vue';

export default {
  name: 'app',
  components: {
    cFull,
  },
};
</script>

<style lang="scss">

</style>
